import React from 'react'
import { Tab, TabProps, withStyles } from '@material-ui/core'
import clsx from 'clsx'

const BFTab = withStyles(theme => ({
  root: {
    minHeight: 0,
    textTransform: 'none',
    opacity: 1,
    '&.small': {
      color: theme.palette.secondary.main,
      height: 30,
      borderRadius: 2,
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '18px',
      padding: 'unset',
      minWidth: 'unset',
      '& $wrapper': {
        '& .MuiSvgIcon-root': {
          marginRight: 5,
          marginBottom: '0!important',
          fontSize: 15,
        },
      },
      '& .MuiTab-wrapper': {
        width: 'unset',
        padding: '4px 17px',
      },
    },
    '&.large': {
      border: '1px solid #E7ECF3',
      background: '#F8FAFC',
      height: 78,
      borderRadius: 3,
      margin: '0 31px 20px 0px',
      minWidth: 204,
      overflow: 'unset',
      '& $wrapper': {
        justifyContent: 'left',
        '& svg': {
          color: theme.palette.grey[400],
        },
      },
    },
  },
  selected: {
    '&.small': {
      color: '#FFFFFF',
      background: theme.palette.primary.main,
    },
    '&.large': {
      height: 98,
      marginBottom: 0,
      paddingTop: 0,
      backgroundColor: theme.palette.primary.contrastText,
      borderBottom: 0,
      borderRadius: '3px 3px 0 0',
      '& $wrapper': {
        marginTop: -21,
        '& svg': {
          color: theme.palette.primary.light,
        },
      },
    },
  },
  wrapper: {
    flexDirection: 'row',
  },
  labelIcon: {
    '&.small': {
      '& $wrapper > *:first-child': {
        marginBottom: 0,
        marginRight: 8,
      },
    },
    '&.large': {
      padding: '18px 19px 17px',
      '& $wrapper > *:first-child': {
        marginBottom: 0,
        marginRight: 15,
      },
    },
  },
  disabled: {
    opacity: 0.5,
  },
}))((props: ITabProps) => {
  const { size, className } = props
  return <Tab {...props} className={clsx(size, className)} />
})

export default BFTab

export interface ITabProps extends TabProps {
  size: 'small' | 'large'
}
